import React from 'react';
import { useNewsUpdates } from '../../hooks/useNewsUpdates';
import { NewsUpdatesApiResponse } from '../../model/NewsUpdatesApiResponse';
import BigEllipse from '../../assets/icons/BigEllipse.svg';
import smallEllipse from '../../assets/icons/smallEllipse.svg';
import NewsModuleCard from './NewsModuleCard';

const NewsModule = ({ className }: { className?: string }) => {
  const { data, isLoading, isError } = useNewsUpdates({ latest: true });

  if (isLoading) return null;
  if (isError) return null;

  if (!data || data.length === 0) {
    return (
      <section className={`w-fit lg:col-span-12 xl:col-span-12 xxl:col-span-12 col-span-12 flex items-start justify-center z-[2] -mt-[85px] ${className}`}>
        <div className="w-full min-[1024px]:w-[976px] min-[1440px]:w-[1296px] max-w-[768px]:w-full mx-auto py-[28px] px-[24px] relative flex flex-col justify-center items-center gap-[10px] bg-white/60 shadow-[0_2px_8px_0_rgba(0,0,0,0.10)] backdrop-blur-[10px] rounded-[40px]">
          <h2 className="body-s text-color-neutral-80">You're all caught up! No updates to review today.</h2>
          <img
            src={BigEllipse}
            width="98" height="98"
            className='absolute bottom-[0] left-[64px]'
          />
          <img
            src={smallEllipse}
            width="50" height="50" className='absolute top-[0] left-[162px] rotate-180'
          />
          <img
            src={BigEllipse}
            width="98" height="98"
            className='absolute -top-[0] right-[113px] rotate-180'
          />
          <img
            src={smallEllipse}
            width="50" height="50"
            className='absolute bottom-[0] right-[63px]'
          />
        </div>
      </section>
    );
  }

  return (
    <section
      className={`w-fit lg:col-span-12 xl:col-span-12 xxl:col-span-12 col-span-12 flex items-start justify-center z-[2] -mt-[85px] ${className}`}
      aria-label="Latest updates"
    >
        <div className="max-[1200px]:w-[976px] min-[1440px]:w-[1296px] max-w-[768px]:w-full mx-auto">
          {data.map((update: NewsUpdatesApiResponse) => (
            <NewsModuleCard
              key={update.id}
              update={update}
            />
          ))}
        </div>
      
    </section>
  );
};

export default NewsModule;